import { mapSearchModelToSearchServiceModel } from '@aviv-search/transformers';
import { Order } from '@search/core/brands/models/Order';
import { createStore } from 'zustand';
export const initialState = {
    searchIndex: 0,
    searchModel: undefined,
    searchServiceModel: undefined,
    seoModel: undefined,
    page: 1,
    order: Order.Default,
    totalCount: 0,
    topPositionId: undefined,
    classifieds: [],
    enlargedClassifieds: [],
    suggestedClassifieds: [],
    classifiedsData: {},
    enrichedClassifiedsData: {},
    pageData: { distributionType: 'buy', estateType: 'house', locations: ['berlin'] },
    featureFlags: {},
    linkboxes: [],
    breadcrumb: [],
    hubContent: {},
    apiError: false,
    gone: false,
    isLoading: true,
    appConfig: {
        loggerName: 'app_serp',
        technicalUrl: '',
        searchEndpoints: {
            search: '',
            enlargement: '',
            effect: undefined,
        },
        countMode: 'default',
        appName: 'serp',
        tracking: {
            initiative: 'wl_serp',
        },
    },
};
export const createAppStore = (initProps) => createStore()((set) => ({
    ...initialState,
    ...initProps,
    setSearchModel: (searchModel) => set({
        searchModel,
        searchServiceModel: mapSearchModelToSearchServiceModel(searchModel),
        seoModel: undefined,
        page: 1,
    }),
    setOrder: (order) => set({ order, page: 1 }),
    setPage: (page) => set({ page }),
    setSerpData: (serpData) => set((currentState) => ({ ...serpData, apiError: false, gone: false, searchIndex: currentState.searchIndex + 1 })),
    setFeatureFlags: (featureFlags) => set({ featureFlags }),
    setApiError: (apiError) => set({ apiError }),
    setGone: (gone) => set({ gone }),
    setIsLoading: (isLoading) => set({ isLoading }),
}));
